import { DeviceToken } from '../../types/User';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { NullableFields, RequiredFieldsOf } from '../../../../types/types';
import { usePatch, UsePatchParams } from '../../../../api/mutations/usePatch';
import { useCallback } from 'react';

type RequiredFieldsForUpdate = 'id' | 'userId';
type MinimalDeviceTokensFields = RequiredFieldsOf<DeviceToken>;
type MinimalDeviceTokens = Pick<DeviceToken, MinimalDeviceTokensFields>;

type DeviceTokenWithOptionalsAsAlsoNullables = Partial<
    MinimalDeviceTokens & NullableFields<Omit<DeviceToken, MinimalDeviceTokensFields>>
>;

export type UpdateDeviceTokensDetails = Omit<DeviceTokenWithOptionalsAsAlsoNullables, RequiredFieldsForUpdate> &
    Pick<DeviceToken, RequiredFieldsForUpdate>;

export type UseUpdateDeviceTokensParams = UsePatchParams<UpdateDeviceTokensDetails, {}>;

export const useUpdateToken = (params: UseUpdateDeviceTokensParams) => {
    const { patch, ...rest } = usePatch<UpdateDeviceTokensDetails, {}>(params);

    const updateToken = useCallback(
        (tokenId: DeviceToken['id'], details: UpdateDeviceTokensDetails) =>
            patch(`${USER_MANAGEMENT_BASE_URL}/${tokenId}`, details),
        [patch]
    );

    return {
        ...rest,
        updateToken
    };
};

export const useUpdateTokens = (params: UseUpdateDeviceTokensParams) => {
    const { patch, ...rest } = usePatch<UpdateDeviceTokensDetails[], {}>(params);

    const updateTokens = useCallback(
        (details: UpdateDeviceTokensDetails[]) => patch(`${USER_MANAGEMENT_BASE_URL}/tokens`, details),
        [patch]
    );

    return {
        ...rest,
        updateTokens
    };
};
